import {
    ALREADY_DEPLOYED_FROM_ANOTHER_TRANSFORMATION,
    ALREADY_UP_TO_DATE,
    ALREADY_USED_AS_PROJECT_INPUT,
    AMBIGUOUS_COLUMN_REFERENCE,
    ANOTHER_INSTANCE_IS_RESPONSIBLE,
    ASSET_DELETION_NOT_PERMITTED,
    ASSET_MODIFICATION_NOT_PERMITTED,
    ASSET_NAME_ALREADY_EXISTS,
    ASSET_NOT_DELETABLE,
    ASSET_NOT_FOUND_BY_SLUG,
    ASSET_PROPERTY_DEFINITION_ALREADY_EXISTS,
    ASSET_PROPERTY_DEFINITION_NOT_FOUND,
    ASSET_PROPERTY_DEFINITION_NOT_MODIFIABLE,
    ASSET_PROPERTY_VALUE_NOT_FOUND,
    API_KEY_OPERATION_NOT_PERMITTED,
    BLEND_CONDITIONS_EMPTY,
    CANCELED,
    CANNOT_CAST_VALUE_OF_TYPE,
    CHAT_GPT_ERROR,
    CHAT_GPT_NOT_CONFIGURED,
    CIRCULAR_REFERENCE,
    CLIENT_CONNECTION_ERROR,
    COLUMN_DOES_NOT_EXIST,
    COLUMN_IS_REFERENCED,
    COLUMN_NAME_ALREADY_EXISTS,
    COMPILATION_FAILED_WITH_DATASET_ERROR,
    COMPILATION_FAILED_WITH_TRANSFORMATION_ERRORS,
    CONFIG_FAILURE,
    CONNECTION_NOT_CONFIGURED,
    DATA_FRESHNESS_CHECK_NOT_MET,
    DATA_LOADING_FAILED,
    DATA_SOURCE_REFERENCE_NOT_FOUND,
    DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED,
    DERIVED_ASSET_MUST_NOT_BE_MODIFIED,
    DUPLICATE_COLUMN_NAMES,
    EMAIL_ADDRESS_ALREADY_TAKEN,
    EMAIL_DOMAIN_NOT_AUTHORIZED,
    ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE,
    EVENT_ID_NOT_FOUND,
    EVENT_SUBSCRIPTION_NOT_FOUND,
    EXPLORATION_NOT_FOUND,
    FAILURE_DURING_SUBMISSION,
    FILE_FORMAT_CHANGED,
    FILE_FORMAT_NOT_SUPPORTED,
    FILE_IS_EMPTY,
    FILE_PARSING_FAILURE,
    FILTER_VALUE_HAS_INCOMPATIBLE_TYPE,
    GITHUB_AUTHENTICATION_ERROR,
    GLOSSARY_CATEGORY_EXISTS,
    GLOSSARY_CATEGORY_NAME_UP_TO_DATE,
    GLOSSARY_CATEGORY_NOT_FOUND,
    GLOSSARY_CATEGORY_STILL_CONTAINS_TERMS,
    GLOSSARY_NOT_MODIFIABLE,
    GLOSSARY_TERM_EXISTS,
    GLOSSARY_TERM_NOT_FOUND,
    GOOGLE_AUTHENTICATION_FAILED,
    GOOGLE_CREDENTIALS_NOT_CONFIGURED,
    GOOGLE_SHEET_ALREADY_IN_USE,
    GOOGLE_SHEET_DOES_NOT_EXIST,
    GOOGLE_SPREADSHEET_NOT_ACCESSIBLE,
    GOOGLE_SPREADSHEET_NOT_FOUND,
    GOOGLE_SPREADSHEET_NOT_WRITABLE,
    GROUP_NOT_FOUND,
    INSUFFICIENT_PRIVILEGES,
    INSUFFICIENT_TASK_PRIVILEGES,
    INVALID_ACCESS_TOKEN,
    INVALID_ACCOUNT_NAME,
    INVALID_EXPRESSION,
    INVALID_IDENTIFIER,
    INVALID_PARAMETER_TYPE_FOR_FUNCTION,
    INVALID_SLACK_CHANNEL_NAME,
    INVALID_SQL_SYNTAX,
    JOB_DEFINITION_NOT_FOUND,
    JOB_RUN_CHECK_FAILED,
    JOB_RUN_NOT_CANCELABLE,
    JOB_RUN_NOT_FOUND,
    JOB_RUN_SKIPPED,
    MAX_FILE_SIZE_EXCEEDED,
    MISSING_COLUMN,
    MISSING_SOURCE_COLUMN,
    MISSING_TABLE,
    NAME_ALREADY_EXISTS,
    NAME_CANNOT_BE_BLANK,
    NO_ACTIVE_WAREHOUSE_SELECTED,
    NO_CSV_CREATED,
    NO_DBT_MODEL_FOUND,
    NO_DEPLOYMENT_HISTORY,
    NO_SAMPLE_FILES_FOUND_BY_PATTERN,
    NODE_ALREADY_IN_GROUP,
    NOT_AUTHENTICATED,
    NOT_AUTHENTICATED_TO_SNOWFLAKE,
    NOT_AUTHORIZED_TO_SLACK,
    NOT_EXISTS_OR_NOT_AUTHORIZED,
    NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED,
    NOT_PERMITTED,
    NOT_SUSPENDED,
    NO_WRITABLE_SCHEMA_FOUND,
    OBJECT_ALREADY_EXISTS,
    OPERATION_NOT_PERMITTED,
    OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS,
    OUTPUT_COLUMNS_WITH_LINE_SEPARATOR,
    OWNER_MUST_NOT_BE_ADDED_AS_COLLABORATOR,
    REFERENCED_COLUM_IN_ERROR,
    REQUIREMENT_NOT_MET,
    SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED,
    SECRET_NOT_FOUND,
    SELF_REFERENCE,
    SEQUENTIAL_JOB_RUN_CHECK_NOT_MET,
    SHARE_NOT_FOUND,
    SLACK_API_CALL_FAILED,
    SLACK_NOT_CONFIGURED,
    SNOWFLAKE_ACCOUNT_NOT_EXISTS_OR_NOT_ACCESSIBLE,
    SNOWFLAKE_INTERNAL_SERVER_ERROR,
    SNOWFLAKE_NOT_CONFIGURED,
    SNOWFLAKE_OBJECT_NOT_FOUND_OR_NOT_ACCESSIBLE,
    SNOWFLAKE_OUTPUT_ALREADY_EXISTS,
    SNOWFLAKE_QUERY_CANCELED,
    SNOWFLAKE_TABLE_ALREADY_EXISTS,
    SNOWFLAKE_SERVICE_ACCOUNT_USER_NOT_EXISTS,
    SOURCE_TRANSFORMATION_NOT_FOUND,
    SQL_NOT_MODIFIED,
    TARGET_TABLE_NOT_EXISTS,
    TABLE_ALREADY_EXISTS,
    TARGET_VIEW_OR_TABLE_NOT_ALLOWED_TO_OVERWRITE,
    TIMEOUT,
    TOKEN_EXPIRED,
    TOO_MANY_ENABLED_USERS,
    TRANSFORMATION_NOT_OPERATIONAL,
    UNCATEGORIZED_SQL_ERROR,
    UNEXPECTED_FAILURE,
    UNKNOWN_COLUMN_REFERENCE,
    UNKNOWN_FUNCTION,
    UNKNOWN_FUNCTIONS,
    UPDATING_OWN_GROUP_NOT_ALLOWED,
    UPLOAD_NOT_FOUND,
    USER_ALREADY_DISABLED,
    USER_ALREADY_ENABLED,
    USER_CANNOT_DISABLE_ITSELF,
    USER_DIFFERS_FROM_TOKEN,
    USER_NOT_FOUND,
    USER_RELATED_DATA_NOT_FOUND,
    USERNAME_ALREADY_TAKEN,
    USERNAME_INVALID,
    SOURCE_VIEW_NOT_EXCHANGEABLE,
    VALUE_NOT_RECOGNIZED,
    VIEW_ALREADY_EXISTS,
    VIEW_IS_A_REFERENCE,
    VIEW_WITH_SAME_NAME_ALREADY_EXISTS,
    WAREHOUSE_SUSPENDED,
    DISCOVERY_FAILURE,
    API_KEY_NOT_FOUND,
    NOT_IN_SLACK_CHANNEL,
    DATAMEER_CHANNEL_NOT_FOUND,
    SLACK_CHANNEL_NOT_FOUND,
    OPERATION_RUN_ERROR
} from 'app/store/__generated__/errors';

/**
 * Setup fallback translation for all defined (backend) errors.
 * Some errors are pretty generic and should be refined on a component level with a clearer messages,
 * some errors are pretty distinct and can safely be sourced from here.
 * But since a bad message is better then no message, we define all of them here.
 */
export const translation = {
    [ALREADY_DEPLOYED_FROM_ANOTHER_TRANSFORMATION]: 'Target name is already in use from another deployed transformation "{{- sourceViewName}}" in project "{{- sourceViewSpaceName}}"',
    [ALREADY_UP_TO_DATE]: 'Already up-to-date.',
    [ALREADY_USED_AS_PROJECT_INPUT]: 'Target name is already used as input in other projects: {{ spaceNames, list }}',
    [AMBIGUOUS_COLUMN_REFERENCE]: 'Column reference "{{column}}" is ambiguous.',
    [ANOTHER_INSTANCE_IS_RESPONSIBLE]: 'Another instance called "{{instance}}" already collects events in the table "{{target.database}}.{{target.schema}}.{{target.table}}".',
    [ASSET_DELETION_NOT_PERMITTED]: 'No permission to delete.',
    [ASSET_MODIFICATION_NOT_PERMITTED]: 'No permission to modify.',
    [ASSET_NAME_ALREADY_EXISTS]: 'Name already exists.',
    [ASSET_NOT_DELETABLE]: 'Not deletable.',
    [ASSET_NOT_FOUND_BY_SLUG]: 'Asset "{{slug}}" does not exist or you are not authorized.',
    [ASSET_NOT_FOUND_BY_SLUG + '_space']: 'No $t(glossary:project) with ID "{{slug}}" was found.',
    [ASSET_NOT_FOUND_BY_SLUG + '_view']: 'No $t(glossary:transformation) with ID "{{slug}}" was found.',
    [ASSET_PROPERTY_DEFINITION_ALREADY_EXISTS]: 'Could not create the property. Did you use a unique name?',
    [ASSET_PROPERTY_DEFINITION_NOT_FOUND]: 'Could not update the property. Did you use a unique name?',
    [ASSET_PROPERTY_DEFINITION_NOT_MODIFIABLE]: 'Could not update the property. It does not exist or you are not authorized.',
    [ASSET_PROPERTY_VALUE_NOT_FOUND]: 'Value of property not found.',
    [API_KEY_NOT_FOUND]: 'API Key not found',
    [API_KEY_OPERATION_NOT_PERMITTED]: 'The specified API key is not allowed to execute the given operation.',
    [BLEND_CONDITIONS_EMPTY]: 'You must specify at least one set of columns as a join criteria.',
    [CANCELED]: 'Query canceled.',
    [CANNOT_CAST_VALUE_OF_TYPE]: 'Cant cast value type "{{sourceColumnType}}" to "{{targetColumnType}}"',
    [CHAT_GPT_ERROR]: 'Chat GPT error: {{code}} / {{- message}}',
    [CHAT_GPT_ERROR + '_invalid_api_key']: 'Invalid API key for ChatGPT provided.',
    [CHAT_GPT_NOT_CONFIGURED]: 'ChatGPT is not configured.',
    [CIRCULAR_REFERENCE]: 'You are attempting to create a circular reference which is not permitted.',
    [CLIENT_CONNECTION_ERROR]: 'There is an issue connecting to Snowflake. Please try again later and/or contact your Snowflake Admin.',
    [COLUMN_DOES_NOT_EXIST]: 'Column does not exist.',
    [COLUMN_IS_REFERENCED]: 'Column is referenced by: {{referencingColumns, list}}.',
    [COLUMN_NAME_ALREADY_EXISTS]: 'Column "{{column}}" already exists.',
    [COMPILATION_FAILED_WITH_DATASET_ERROR]: 'Dataset has structural problems.',
    [COMPILATION_FAILED_WITH_TRANSFORMATION_ERRORS]: 'Dataset has structural problems.',
    [CONFIG_FAILURE]: 'Configuration not updated: {{- message }}',
    [CONNECTION_NOT_CONFIGURED]: 'Snowflake is not configured.',
    [NO_CSV_CREATED]: 'Query returned no data.',
    [NO_DBT_MODEL_FOUND]: 'No DBT model found for {{database}}.{{schema}}.{{table}}',
    [NO_SAMPLE_FILES_FOUND_BY_PATTERN]: 'No data sample found for given search pattern.',
    [NOT_IN_SLACK_CHANNEL]: 'The configured Slack user is not a member of the selected Slack channel',
    [DATA_FRESHNESS_CHECK_NOT_MET]: 'The check for data freshness has failed.',
    [DATA_LOADING_FAILED]: 'Could not load data: {{- message}}',
    [DATA_SOURCE_REFERENCE_NOT_FOUND]: 'Could not find reference to Data Source',
    [DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED]: 'The database "{{database}}" does not exist or you are not authorized.',
    [DATAMEER_CHANNEL_NOT_FOUND]: 'The selected Datameer channel can not be found',
    [DERIVED_ASSET_MUST_NOT_BE_MODIFIED]: 'No permissions to modify.',
    [DISCOVERY_FAILURE]: 'Configuration failed: {{- error}}',
    [DUPLICATE_COLUMN_NAMES]: 'Duplicate column name(s): {{ columnNames, list }}',
    [EMAIL_ADDRESS_ALREADY_TAKEN]: 'Email address already in use by one of your other $t(common:productName) users.',
    [EMAIL_DOMAIN_NOT_AUTHORIZED]: 'Email address not in the list of allowed domains for your $t(common:productName) instance.',
    [ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE]: 'The entity {{entityId}} does not exist or you are not authorized.',
    [ENTITY_NOT_FOUND_OR_NOT_ACCESSIBLE + '_datasource']: 'The $t(glossary:datasource) {{entityId}} does not exist or you are not authorized.',
    [EVENT_ID_NOT_FOUND]: 'The event id was not found.',
    [EVENT_SUBSCRIPTION_NOT_FOUND]: 'The event subscription was not found.',
    [EXPLORATION_NOT_FOUND]: 'Exploration could not be found anymore.',
    [FAILURE_DURING_SUBMISSION]: 'Error during submission of the Snowflake query: {{errorMessage}}',
    [FILE_FORMAT_CHANGED]: 'The file format has changed between the current job run and the job creation. {{- changes}}',
    [FILE_FORMAT_NOT_SUPPORTED]: 'Error the file format "{{fileFormatType}}" is not supported.',
    [FILE_IS_EMPTY]: 'The uploaded file is empty.',
    [FILE_PARSING_FAILURE]: 'The uploaded file could not be parsed: {{- message}}',
    [FILTER_VALUE_HAS_INCOMPATIBLE_TYPE]: 'Invalid value for column of type {{columnTypeFamily}}',
    [GITHUB_AUTHENTICATION_ERROR]: '{{- message}}',
    [GLOSSARY_CATEGORY_EXISTS]: 'Category "{{name}}" already exists.',
    [GLOSSARY_CATEGORY_NAME_UP_TO_DATE]: 'Category "{{name}}" already updated.',
    [GLOSSARY_CATEGORY_NOT_FOUND]: 'Category "{{name}}" not found.',
    [GLOSSARY_CATEGORY_STILL_CONTAINS_TERMS]: 'Category "{{categoryName}}" still contain terms.',
    [GLOSSARY_NOT_MODIFIABLE]: 'No permission to modify.',
    [GLOSSARY_TERM_EXISTS]: 'Term "{{name}}" already exists in category "{{categoryName}}".',
    [GLOSSARY_TERM_NOT_FOUND]: 'Term "{{name}}" not found.',
    [GOOGLE_AUTHENTICATION_FAILED]: 'Authenticating to Google Sheets API failed: {{- message}}',
    [GOOGLE_AUTHENTICATION_FAILED + '_invalid_grant']: 'Authenticating to Google Sheets API failed: Invalid Grant. Make sure the service account is activated and has access to the Google Sheets API.',
    [GOOGLE_CREDENTIALS_NOT_CONFIGURED]: 'Google Sheets is not configured. Upload Service Account credentials in Integrations settings.',
    [GOOGLE_SHEET_ALREADY_IN_USE]: 'The sheet is already in use by "{{name}}"',
    [GOOGLE_SHEET_DOES_NOT_EXIST]: 'Google Sheet "{{sheetId}}" not found.',
    [GOOGLE_SPREADSHEET_NOT_ACCESSIBLE]: 'The spreadsheet is not accessible. Share it with "{{clientEmail}}" as editor.',
    [GOOGLE_SPREADSHEET_NOT_FOUND]: 'Google Spreadsheet "{{spreadsheetId}}" does not exist.',
    [GOOGLE_SPREADSHEET_NOT_WRITABLE]: 'Could not write to Google Spreadsheet. Make sure the spreadsheet is shared with editor permissions',
    [GROUP_NOT_FOUND]: 'No Group with given id found',
    [INSUFFICIENT_PRIVILEGES]: 'Insufficient privileges: {{- message}}',
    [INSUFFICIENT_TASK_PRIVILEGES]: 'Scheduling is not allowed. No privileges to EXECUTE TASK and EXECUTE MANAGED TASK granted in Snowflake.',
    [INVALID_ACCESS_TOKEN]: 'Invalid OAuth access token.',
    [INVALID_ACCOUNT_NAME]: 'Snowflake Account Name or URL is invalid: {{- originalMessage}}',
    [INVALID_EXPRESSION]: 'Invalid formula.',
    [INVALID_IDENTIFIER]: 'Unknown column "{{column}}" referenced.',
    [INVALID_PARAMETER_TYPE_FOR_FUNCTION]: 'Invalid parameter value "{{parameterValue}}" for function "{{function}}".',
    [INVALID_SLACK_CHANNEL_NAME]: 'The Slack channel name is invalid.',
    [INVALID_SQL_SYNTAX]: 'Invalid SQL syntax: {{- message}}',
    [JOB_DEFINITION_NOT_FOUND]: 'The job definition does not exist.',
    [JOB_RUN_CHECK_FAILED]: 'Pre-flight checks failed for the Job Run.',
    [JOB_RUN_NOT_CANCELABLE]: 'This Job Run cannot be canceled.',
    [JOB_RUN_NOT_FOUND]: 'No job run with this id found.',
    [JOB_RUN_SKIPPED]: 'Job run was skipped.',
    [MAX_FILE_SIZE_EXCEEDED]: 'File size limit ({{maxFileSizeHumanReadable}}) exceeded, filter out more data or create a new View or Table',
    [MISSING_COLUMN]: 'Unknown column "{{column}}" referenced.',
    [MISSING_SOURCE_COLUMN]: 'Column "{{- columnName}}" contains a reference to a source column that does not exist in expression "{{- expression}}"',
    [MISSING_TABLE]: 'Table "{{qualifiedTable}}" does not exist.',
    [NAME_ALREADY_EXISTS]: 'Name already exists.',
    [NAME_CANNOT_BE_BLANK]: 'Name cannot be blank.',
    [NO_ACTIVE_WAREHOUSE_SELECTED]: 'No warehouse selected. Please make sure that a default warehouse is defined for your Snowflake user.',
    [NO_DEPLOYMENT_HISTORY]: 'No deployment history found.',
    [NODE_ALREADY_IN_GROUP]: 'You cannot create a group if any of your selected nodes are already in a group.',
    [NOT_AUTHENTICATED]: 'Failed to authenticate.',
    [NOT_AUTHENTICATED_TO_SNOWFLAKE]: 'Sign-in to Snowflake required.',
    [NOT_AUTHORIZED_TO_SLACK]: 'Not Authorized to Slack.',
    [NOT_EXISTS_OR_NOT_AUTHORIZED]: 'Required "{{identifier.database}}.{{identifier.schema}}.{{identifier.table}}" does not exist or you are not authorized.',
    [NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED]: 'Does not exist or you are not authorized.',
    [SLACK_CHANNEL_NOT_FOUND]: 'The selected Slack channel can not be found',
    [NOT_PERMITTED]: 'No permission.',
    // ui does not need this
    [NOT_SUSPENDED]: '',
    [NO_WRITABLE_SCHEMA_FOUND]: 'Your current user/role does not have any writable schema to write to. This is required for caching datasets.',
    [OBJECT_ALREADY_EXISTS]: 'Object already exists: {{- message}}',
    [OPERATION_NOT_PERMITTED]: 'No permission to configure Snowflake. Contact your local system administrator.',
    [OPERATION_RUN_ERROR]: 'Operation Error: {{- message}}',
    [OUTPUT_COLUMNS_WITH_INVISIBLE_CONTROL_CHARACTERS]: 'The SQL query results in columns with invisible characters in their names. Please alias your SELECT expressions to make them consumable downstream.',
    [OUTPUT_COLUMNS_WITH_LINE_SEPARATOR]: 'The SQL query results in columns with newlines in their names. Please alias your SELECT expressions to make them consumable downstream.',
    [OWNER_MUST_NOT_BE_ADDED_AS_COLLABORATOR]: 'You cannot add the owner as collaborator.',

    [REFERENCED_COLUM_IN_ERROR]: 'Referenced column "{{columnName}} has an error.',
    [REQUIREMENT_NOT_MET]: '{{- requirementNotMet }}',
    [SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED]: 'The schema {{schema}} does not exist or you are not authorized.',
    [SECRET_NOT_FOUND]: 'Snowflake configuration is incomplete (secret is missing).',
    [SELF_REFERENCE]: 'Self references are not allowed.',
    [SEQUENTIAL_JOB_RUN_CHECK_NOT_MET]: 'Job Run was not triggered because the same Job is already running.',
    [SHARE_NOT_FOUND]: 'Email schedule not found.',
    [SLACK_API_CALL_FAILED]: 'Slack API call failed.',
    [SLACK_NOT_CONFIGURED]: 'Slack Integration is not available. Contact Datameer Support for further assistance.',
    [SNOWFLAKE_ACCOUNT_NOT_EXISTS_OR_NOT_ACCESSIBLE]: 'The Snowflake account "{{account}}" either does not exist or is not accessible.',
    [SNOWFLAKE_INTERNAL_SERVER_ERROR]: 'Snowflake encountered an internal communication error. Please retry your operation.',
    [SNOWFLAKE_NOT_CONFIGURED]: 'Snowflake is not configured.',
    [SNOWFLAKE_OBJECT_NOT_FOUND_OR_NOT_ACCESSIBLE]: 'Table "{{qualifiedTable}}" does not exist or you are not authorized.',
    [SNOWFLAKE_OUTPUT_ALREADY_EXISTS]: 'A Project Output for the Snowflake table already exists.',
    [SNOWFLAKE_QUERY_CANCELED]: 'Snowflake query canceled',
    [SNOWFLAKE_TABLE_ALREADY_EXISTS]: 'Target table already exists, choose another name.',
    [SNOWFLAKE_SERVICE_ACCOUNT_USER_NOT_EXISTS]: 'The selected Snowflake Service Account User does not exist.',
    [SOURCE_TRANSFORMATION_NOT_FOUND]: 'Could not find the source transformation.',
    [SQL_NOT_MODIFIED]: 'The SQL is not modified.',
    [TARGET_TABLE_NOT_EXISTS]: 'The target table "{{table}}" not exists.',
    [TABLE_ALREADY_EXISTS]: '"{{table}}" already exists. Please choose another name.',
    [TARGET_VIEW_OR_TABLE_NOT_ALLOWED_TO_OVERWRITE]: 'Target table already exists, choose another name.',
    [TIMEOUT]: 'Snowflake query timed out after {{time}}.',
    [TOKEN_EXPIRED]: 'Authentication token expired.',
    [TOO_MANY_ENABLED_USERS]: 'More then {{maximum}} users activated.',
    [TRANSFORMATION_NOT_OPERATIONAL]: 'The transformation cannot be deployed because it has one or more errors.',
    [UNCATEGORIZED_SQL_ERROR]: '{{-message}}',
    [UNEXPECTED_FAILURE]: 'Unexpected failure: {{- message}}',
    [UNKNOWN_COLUMN_REFERENCE]: 'Following referenced columns are missing: {{unknownColumns, list}}',
    [UNKNOWN_FUNCTION]: 'Unknown function "{{function}}".',
    [UNKNOWN_FUNCTIONS]: 'Unknown functions: {{functionNames, list}}',
    [UPLOAD_NOT_FOUND]: 'Failed to load the uploaded file.',
    [UPDATING_OWN_GROUP_NOT_ALLOWED]: 'Updating your own group is not allowed.',
    [USER_ALREADY_DISABLED]: 'User {{username}} already disabled.',
    [USER_ALREADY_ENABLED]: 'User {{username}} already enabled.',
    [USER_CANNOT_DISABLE_ITSELF]: 'You cannot disable yourself.',
    [USER_DIFFERS_FROM_TOKEN]: 'The user you were trying to authenticate as differs from the user tied to the access token.',
    [USER_NOT_FOUND]: 'User {{username}} not found.',
    [USER_RELATED_DATA_NOT_FOUND]: 'Cannot find data for user {{username}}',
    [USERNAME_ALREADY_TAKEN]: 'Username already in use by one of your other $t(common:productName) users.',
    [USERNAME_INVALID]: 'Username "{{username}}" is invalid.',
    [SOURCE_VIEW_NOT_EXCHANGEABLE]: 'Failed to exchange source: {{- message}}',
    [VALUE_NOT_RECOGNIZED]: 'Unexpected non-"{{targetType}}" value in data: "{{notRecognizedValue}}". This is likely to be caused by a data type coercing/casting.',
    [VIEW_ALREADY_EXISTS]: 'Dataset "{{viewName}} already exist."',
    [VIEW_IS_A_REFERENCE]: 'Cannot update a datasource reference.',
    [VIEW_WITH_SAME_NAME_ALREADY_EXISTS]: 'Cannot materialize a view.',
    [WAREHOUSE_SUSPENDED]: 'Configured Snowflake warehouse "{{warehouse}}" is suspended and no auto-resume is configured.',

    // Job run warnings
    NoRowsProduced: 'Table materialization produced no rows.',

    // TransformationError(s) which are not generated by the backend (some overlap with regular error though)
    AggregationError: '{{- cause}}',
    AmbiguousOutputColumns: 'Transformation produces more then one column with the name "{{columnName}}".',
    FormulaCircularReference: 'You are attempting to create a circular reference which is not permitted.',
    DuplicateColumnName: 'Duplicate column "{{columnName}}".',
    IllegalAlias: 'Column "{{columnName}}" cannot be renamed to a column that already exists in predecessor Schema.',
    PivotError: '{{- cause}}',
    UnknownColumnNames: 'Following referenced columns are missing: {{columnNames, list}}',

    // DatasetError(s) which in some cases are not generated by the backend
    ErrorInReference: 'The referenced dataset or transformation has failures. Please fix those first!',

    // APIv2

    UnknownColumnNamesWithSource: 'Source dataset referencing unknown column(s): {{ columnNames, list }}',
    MissingPrivateKeyPassphrase: 'Private Key is protected by a passphrase, please enter below.',
    IncorrectPrivateKeyPassphrase: 'Incorrect Private Key passphrase.'
};
